var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartnerWhitesvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 69,
    viewBox: "0 0 92 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.557083 68.1516H40.9141V28.5626H13.8048C11.8816 17.5429 19.9257 6.65935 24.1882 2.59502L22.4491 -0.00684357C7.6771 4.84996 1.69942 22.7296 0.557083 31.0624V68.1516Z",
    fill: "white",
    fillOpacity: 0.99
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7797 68.1516H91.1367V28.5626H64.0275C62.1042 17.5429 70.1484 6.65935 74.4108 2.59502L72.6717 -0.00684357C57.8998 4.84996 51.9221 22.7296 50.7797 31.0624V68.1516Z",
    fill: "white",
    fillOpacity: 0.99
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerWhitesvg);
export default __webpack_public_path__ + "static/media/partner-whitesvg.5b8c2a6c9b68b439ed25451c4646ec64.svg";
export { ForwardRef as ReactComponent };